import SectionHeading from './SectionHeading'
import SectionSubText from './SectionSubText'

/**
 * Free Resources section (two-column checklist + hero circle art)
 * Based closely on provided mock.
 */
export default function FreeResources() {
    const left = [
        {
            title: 'Business Setup Checklist',
            desc: 'step-by-step guide to building your foundation.',
        },
        {
            title: 'Recommended Prospect Lists',
            desc: '– our insider lists for the best contacts.',
        },
        {
            title: 'General List Criteria',
            desc: '– simple framework for identifying motivated sellers.',
        },
        {
            title: 'FOIA Request Template',
            desc: '– request tax liens & public records with ease.',
        },
        {
            title: 'Deal Analysis Tool',
            desc: '– evaluate profitability with confidence.',
        },
    ]

    const right = [
        {
            title: 'Purchase Contract',
            desc: '– ready-to-use template for buying & selling real estate.',
        },
        {
            title: 'Assignment Contract',
            desc: '– template for assigning deals to other buyers.',
        },
        {
            title: 'Agreement to Extend Closing Date',
            desc: '– template to extend deal deadlines.',
        },
        {
            title: 'Phone Scripts',
            desc: '– proven conversation guides for sellers & leads.',
        },
    ]

    const Check = () => (
        <img
            src="/assets/better-direct-mail/check-bullet-icon.svg"
            alt=""
            className="h-5 w-5 md:h-6 md:w-6"
        />
    )

    return (
        <section className="py-10 md:py-14">
            <div className="relative px-5 md:px-10">
                {/* Heading + subtext */}
                <div className="max-w-5xl mx-auto text-center">
                    <SectionHeading>
                        <span className="text-secondary">
                            Free Resources to Kickstart or
                            <br className="hidden md:block" /> Boost Your REI
                            Business
                        </span>
                    </SectionHeading>
                    <SectionSubText size={'max-w-5xl'}>
                        Switching to OLM means more than better direct mail — we
                        equip you with the tools and templates successful
                        investors use every day. Fill out the form below and get
                        instant access to essential resources — completely free.
                    </SectionSubText>
                </div>

                {/* Content grid */}
                <div className="mt-10 md:mt-14 grid grid-cols-1 lg:grid-cols-12 gap-10 max-w-6xl mx-auto items-center">
                    {/* Left: two-column checklist */}
                    <div className="lg:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-6">
                        <ul className="space-y-6">
                            {left.map((it) => (
                                <li
                                    key={it.title}
                                    className="flex items-start gap-3">
                                    <span className="mt-1 inline-flex shrink-0 text-secondary">
                                        <Check />
                                    </span>
                                    <p className="text-olm-new-black/90 text-base md:text-[17px] leading-7">
                                        <span className="font-semibold">
                                            {it.title}
                                        </span>{' '}
                                        {it.desc}
                                    </p>
                                </li>
                            ))}
                        </ul>
                        <ul className="space-y-6">
                            {right.map((it) => (
                                <li
                                    key={it.title}
                                    className="flex items-start gap-3">
                                    <span className="mt-1 inline-flex shrink-0 text-secondary">
                                        <Check />
                                    </span>
                                    <p className="text-olm-new-black/90 text-base md:text-[17px] leading-7">
                                        <span className="font-semibold">
                                            {it.title}
                                        </span>{' '}
                                        {it.desc}
                                    </p>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="lg:col-span-5">
                        <img
                            src="/assets/better-direct-mail/promise-banner.webp"
                            alt=""
                            className="w-full"
                        />
                    </div>
                </div>
            </div>
        </section>
    )
}
